module.exports = __webpack_public_path__ + "static/img/GemsofOlympus.cc416b71.png";